import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { DataResidencyBanner } from '@mc-prime/einstein-ui-components';

import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';

import { BrandBand } from '../../common/components';
import { Header, SetupMenu } from '../components/';

import './Setup.scss';
import getStackUrl from '../../utilities/getStackUrl';

export class Setup extends Component {
  componentDidMount() {
    this.props.actions.getActivationStatus({ ignoreErrors: true });
    this.props.actions.getRules();
  }

  render() {
    const { formatMessage } = this.props.intl;
    const regex = /[2,3,4]0[1,2,3,6]/;
    const stackUrl = getStackUrl() || '';
    const displayResidencyBanner = !!stackUrl.match(regex) || false;
    const helpLink =
      'https://help.salesforce.com/s/articleView?id=sf.mc_anb_data_residency_hyperforce.htm&type=5';
    return (
      <div>
        {displayResidencyBanner ? (
          <DataResidencyBanner>
            <FormattedMessage
              id={'components.ecs.setup.dataResidency'}
              values={{
                link: (
                  <a rel="noopener noreferrer" target="_blank" href={helpLink}>
                    {formatMessage({
                      id: 'components.ecs.setup.learnMore'
                    })}
                  </a>
                )
              }}
            />
          </DataResidencyBanner>
        ) : null}
        <BrandBand>
          <Header route={this.props.match} />
          <SetupMenu
            actions={this.props.actions}
            rules={this.props.rules}
            modals={this.props.modals}
            activation={this.props.activation}
            toast={this.props.toast}
            profileUpload={this.props.profileUpload}
            assets={this.props.assets}
            attributes={this.props.attributes}
          />
        </BrandBand>
      </div>
    );
  }
}

Setup.contextTypes = {
  router: PropTypes.object
};

Setup.propTypes = {
  activation: PropTypes.object,
  rules: PropTypes.object,
  modals: PropTypes.object,
  assets: PropTypes.object,
  attributes: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    activation: state.ecs.activation,
    modals: state.modals,
    profileUpload: state.ecs.profileUpload,
    rules: state.ecs.rules,
    assets: state.ecs.assets,
    attributes: state.ecs.attributes,
    toast: state.toast
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Setup));
